const validateRetraction = function ({ commit, state }) {
  commit("VALIDATE_RETRACTION");

  return Promise.resolve(state.retractionErrors);
};

export default validateRetraction;
